import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { ToastItemComponent } from './toast-item/toast-item.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonDirective } from '@directives/button.directive';

@NgModule({
    declarations: [ToastComponent, ToastItemComponent],
    imports: [CommonModule, SvgIconComponent, ButtonDirective],
    exports: [ToastComponent],
})
export class ToastModule {}
